import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { initMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <LandingPage data-id="element-0" />;
}